<template>
  <VueSelect
    v-bind="$attrs"
    :model-value="modelValue"
    :components="selectComponents"
    @update:model-value="updateValue"
  >
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}" />
    </template>
  </VueSelect>
</template>

<script>
import { h } from "vue";
import FeatherIcon from "./FeatherIcon.vue";
import VueSelect from "@/vendor/vue-select";

const Deselect = {
  name: "VueSelectDeselect",
  render() {
    return h(FeatherIcon, {
      icon: "XIcon",
      svgClasses: "w-4 h-4 mt-1",
    });
  },
};

const OpenIndicator = {
  name: "VueSelectOpenIndicator",
  render() {
    return h(FeatherIcon, {
      icon: "ChevronDownIcon",
      svgClasses: "w-5 h-5",
    });
  },
};

export default {
  name: "VSelect",
  components: {
    VueSelect,
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      default: null,
    },
    components: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:modelValue", "input"],
  computed: {
    selectComponents() {
      return {
        Deselect,
        OpenIndicator,
        ...this.components,
      };
    },
  },
  methods: {
    updateValue(value) {
      this.$emit("update:modelValue", value);
      this.$emit("input", value);
    },
  },
};
</script>
